import React from 'react';
import { Dayjs } from 'dayjs';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import generatePicker, { PickerDateProps, PickerTimeProps, RangePickerDateProps } from 'antd/es/date-picker/generatePicker';
import { CommonPickerMethods } from 'antd/lib/date-picker/generatePicker/interface';
// import 'antd/es/date-picker/style/index';

export type DatePickerProps = Omit<PickerDateProps<Dayjs>, 'picker'>;
export type TimePickerProps = Omit<PickerTimeProps<Dayjs>, 'picker'>;
export type DateRangePickerProps = RangePickerDateProps<Dayjs>;

export const GenDatePicker = generatePicker<Dayjs>(dayjsGenerateConfig);
export const GenTimePicker = GenDatePicker.TimePicker;
export const GenRangePicker = GenDatePicker.RangePicker;

export type DateRangePickerRef = InstanceType<typeof GenRangePicker> & CommonPickerMethods;

export const DatePicker: React.FC<DatePickerProps> = (props) => {
  return <GenDatePicker {...props} />
}

export const TimePicker = React.forwardRef<any, TimePickerProps>((props, ref) => {
  return <GenTimePicker {...props} mode={undefined} ref={ref} />;
});

export const DateRangePicker = React.forwardRef<DateRangePickerRef, DateRangePickerProps>((props, ref) => {
  return <GenRangePicker {...props} ref={ref} />
});
